(function(window, prevNextControlsViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.PrevNextControlsView = prevNextControlsViewFactory(namespace.localizationStrings, namespace.templates, namespace.cssClasses, namespace.events, namespace.tabIndex);
})(this, function(localizationStrings, templates, cssClasses, events, tabIndex) {
   'use strict';

   var PrevNextControlsView = function($container) {
      var _markup = templates.prev_next_controls_template({
         accessBtnPrevious: localizationStrings.strings.accessBtnPrevious,
         accessBtnNext: localizationStrings.strings.accessBtnNext,
         previousIndex: tabIndex.Previous,
         nextIndex: tabIndex.Next
      });
      $container.find('.prev-next-controls').html(_markup);

      var _$previousControl = $container.find('.previous-control');
      var _$nextControl = $container.find('.next-control');

      var disableKeyListeners = function() {
         _$previousControl.attr('tabindex', tabIndex.Disabled);
         _$nextControl.attr('tabindex', tabIndex.Disabled);
      };

      var enableKeyListeners = function() {
         _$previousControl.attr('tabindex', tabIndex.Previous);
         _$nextControl.attr('tabindex', tabIndex.Next);
      };

      $container.on(events.Controls.Disable, disableKeyListeners);
      $container.on(events.Controls.Enable, enableKeyListeners);

      _$previousControl.click(function() {
         $container.trigger(events.Controls.ClickPrev);
      });

      _$nextControl.click(function() {
         $container.trigger(events.Controls.ClickNext);
      });

      var hide = function() {
         _$previousControl.addClass(cssClasses.hide);
         _$nextControl.addClass(cssClasses.hide);
      };

      var show = function() {
         _$previousControl.removeClass(cssClasses.hide);
         _$nextControl.removeClass(cssClasses.hide);
      };

      var disablePreviousButton = function() {
         _$previousControl.addClass(cssClasses.disabled).attr('aria-disabled', true);
      };

      var enablePreviousButton = function() {
         _$previousControl.removeClass(cssClasses.disabled).attr('aria-disabled', false);
      };

      var disableNextButton = function() {
         _$nextControl.addClass(cssClasses.disabled).attr('aria-disabled', true);
      };

      var enableNextButton = function() {
         _$nextControl.removeClass(cssClasses.disabled).attr('aria-disabled', false);
      };

      return {
         show: show,
         hide: hide,
         disablePreviousButton: disablePreviousButton,
         enablePreviousButton: enablePreviousButton,
         disableNextButton: disableNextButton,
         enableNextButton: enableNextButton
      };
   };

   return {
      create: PrevNextControlsView
   };
});
